export type SortDir = "asc" | "desc";


export type SortValueType = "text" | "number";

export type SortState = {
  sortBy: string | null;
  sortDir: SortDir;
};

export const DEFAULT_SORT: SortState = { sortBy: null, sortDir: "asc" };


export function applySort(key: string, direction: SortDir | null): SortState {
  if (direction === null) return DEFAULT_SORT;
  return { sortBy: key, sortDir: direction };
}

/**
 * Appends sort_by/sort_dir to `params` when a column is actively sorted.
 * At the default (unsorted) state neither param is sent, preserving each
 * endpoint's existing default ordering. Pass `sortByParam`/`sortDirParam`
 * for endpoints with multiple independent sort pairs (e.g.
 * manager_sort_by/manager_sort_dir vs client_sort_by/client_sort_dir).
 */
export function appendSortParams(
  params: URLSearchParams,
  sort: SortState,
  options?: { sortByParam?: string; sortDirParam?: string },
): void {
  if (!sort.sortBy) return;
  params.set(options?.sortByParam ?? "sort_by", sort.sortBy);
  params.set(options?.sortDirParam ?? "sort_dir", sort.sortDir);
}
